import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';
import axios from "axios";
import {ClientSessionReadOnly} from "../client/ClientSessionReadOnly";
import {Accordion, Button} from "react-bootstrap";
import {useCookies} from "react-cookie";
import {validatePhoneNumber} from "../utils";

export const PostReviewView = (props: { qrCode: string, postAction: any, isExpanded: boolean}) => {

    const [cookies, setCookie] = useCookies(['qme_customer']);
    const cookieName = cookies.qme_customer ? cookies.qme_customer["name"] : null
    const cookiePhoneNumber = cookies.qme_customer ? cookies.qme_customer["phone"] : null

    const [enteredOtp, setEnteredOtp] = useState(null)

    const [error, setError] = useState(null)
    const [vote, setVote] = useState("NO")
    const [reviewGiven, setReviewGiven] = useState(null)
    const [phoneNumber, setPhoneNumber] = useState(cookiePhoneNumber)
    const [name, setName] = useState(cookieName)
    const [otpGenerated, setOtpGenerated] = useState(false)

    const [reviews, setReviews] = useState<Array<any>>([])
    const [totalReviews, setTotalReviews] = useState(0)
    const [offSet, setOffset] = useState(0)


    useEffect(() => {
        if (props.qrCode) {
            fetchReviews()
        }
    }, [props.qrCode])

    const fetchReviews = () => {
        axios.post('/api/backend/reviews/fetch/' + props.qrCode, {offset: offSet, limit: 5})
            .then(resp => {
                console.log(resp.data)
                if (resp.data) {
                    setTotalReviews(resp.data.totalReviews)
                    setOffset(oldOffset => oldOffset + 5)
                    setReviews(oldReviews => {
                        return oldReviews
                        && oldReviews.length > 0
                        && resp.data.reviews
                        && resp.data.reviews.length > 0
                        && oldReviews[0].reviewerMobile == resp.data.reviews[0].reviewerMobile
                            ? oldReviews
                            : [...oldReviews, ...resp.data.reviews]
                    })
                }
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
            });
    }

    const handleVoteChange = (voteChanged: String) => {
        if (voteChanged == "UP") {
            if (vote == 'UP') {
                setVote("NO")
            } else {
                setVote("UP")
            }
        }
        if (voteChanged == "DOWN") {
            if (vote == 'DOWN') {
                setVote("NO")
            } else {
                setVote("DOWN")
            }
        }
    }

    const handlePost = () => {
        if (cookies.qme_customer && phoneNumber == cookiePhoneNumber && name == cookieName) {
            postReview()
        } else {
            if (!validatePhoneNumber(phoneNumber)) {
                setError("* Please provide correct mobile number")
                return
            } else {
                setError(null)
            }
            axios.post('/api/backend/user/send/otp', {mobile: phoneNumber, role: "customer"})
                .then(resp => {
                    if (resp.data) {
                        setOtpGenerated(true)
                    } else {
                        setError("* User not found. Please use registered mobile number")
                    }
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
                });
        }
    }

    function postReview() {
        axios.post('/api/backend/reviews/create', {
            qrCode: props.qrCode,
            reviewText: reviewGiven,
            reviewerMobile: phoneNumber,
            reviewerName: name,
            voteType: vote
        })
            .then(resp => {
                if (resp.data) {
                    props.postAction()
                } else {
                    setError("Thanks for review! Your review has already been captured")
                }
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
            });
    }

    const handleValidateOtp = () => {
        axios.post('/api/backend/user/customer/validate/otp', {mobile: phoneNumber, otp: enteredOtp})
            .then(resp => {
                if (!resp.data) {
                    setError("* Incorrect OTP")
                    return
                } else {
                    setCookie('qme_customer', {"phone": phoneNumber, "name": name}, {maxAge: 2630000})
                    setError(null)
                }
                postReview()
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() };
            });
    };

    function getReviews() {
        return reviews && reviews.length > 0 && <div className="p-2">
            <div className="py-4 font-weight-bold fs-4"> Reviews</div>
            {reviews.map(review => {
            return review.reviewText && <div key={"review"} className="text-secondary">
                <div className="font-weight-bold d-inline-block">{review.reviewerName}</div>
                {review.voteType == "up" && <img alt="review-view-page-icon" height="30rem" width="30rem" src="/upvote.png"
                                                 className="align-self-center  d-inline-block"/>
                }
                {review.voteType == "down" && <img alt="review-view-page-icon" height="30rem" width="30rem" src="/downvote.png"
                                                   className="align-self-center  d-inline-block"/>
                }
                <p>{review.reviewText}</p>
            </div>
        })}
        </div>
    }


    return (
        <>
            <Accordion className="" defaultActiveKey="0">
                <Accordion.Item eventKey={props.isExpanded? "0" : "1"}>
                    <Accordion.Header>
                        Post a Review
                    </Accordion.Header>
                    <Accordion.Body>
                        {!otpGenerated &&
                            <div>
                                <div className="input-group mt-3 mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text" id="basic-addon1">+91 -</span>
                                    </div>
                                    <input type="tel" placeholder="Enter phone number"
                                           onChange={(e) => setPhoneNumber(e.target.value)}
                                           className="form-control"/>
                                </div>
                                <input type="text" placeholder="Enter Name"
                                       onChange={(e) => setName(e.target.value)}
                                       className="form-control my-3"/>
                                <a href="#/" onClick={e => handleVoteChange("UP")}>
                                    {vote && vote == "UP" &&
                                        <img alt="review-view-page-icon" height="50rem" width="50rem" src="/upvote.png"
                                             className="align-self-center"/>

                                    }
                                    {(!vote || vote != "UP") &&
                                        <img alt="review-view-page-icon" height="50rem" width="50rem" src="/upvote_not_selected.png"
                                             className="align-self-center"/>
                                    }
                                </a>
                                <a href="#/" onClick={e => handleVoteChange("DOWN")}>
                                    {vote && vote == "DOWN" &&
                                        <img alt="review-view-page-icon" height="50rem" width="50rem" src="/downvote.png"
                                             className="align-self-center"/>

                                    }
                                    {(!vote || vote != "DOWN") &&
                                        <img alt="review-view-page-icon" height="50rem" width="50rem" src="/downvote_not_selected.png"
                                             className="align-self-center"/>
                                    }
                                </a>
                                <textarea placeholder="Write a review..."
                                          onChange={(e) => setReviewGiven(e.target.value)}
                                          className="form-control my-3"/>

                                <button className="btn btn-warning text-white"
                                        onClick={handlePost}> Submit
                                </button>
                            </div>
                        }
                        {otpGenerated &&
                            <div className="py-5">
                                <input type="tel" maxLength={6} placeholder="Enter OTP"
                                       onChange={(e) => setEnteredOtp(e.target.value)}
                                       className="form-control my-3"/>
                                <Button onClick={handleValidateOtp} className="form-control btn btn-info text-white"> Validate OTP</Button>
                            </div>
                        }
                        {error &&
                            <div className="my-3 text-danger fs-6">{error}</div>
                        }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            {getReviews()}
            {reviews.length < totalReviews &&
                <div><a className="text-secondary" onClick={fetchReviews}>Show more...</a><br/><br/></div>
            }
        </>
    );
};
